import { render, staticRenderFns } from "./PaperViewer.vue?vue&type=template&id=202d4ed8"
import script from "./PaperViewer.vue?vue&type=script&lang=js"
export * from "./PaperViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports